import React from "react";
import Switch from "react-switch";
import {
    VendorDownloadSvg,
    VendorTrashSvg,
    VendorShareSvg,
    VendorInfoSvg,
    VendorKebabSvg,
} from "../../../components/CommonSvg";
import {
    fileKind,
    fileSize,
    uploadedOn,
    downloadName,
    ownerInitials,
} from "./documentUtils";

const DocumentRow = ({
    document,
    canUpload,
    canDownload,
    statusUpdating,
    showCategoryTag,
    menuOpen,
    onToggleMenu,
    onDetails,
    onDownload,
    onShare,
    onDelete,
    onToggleStatus,
}) => {
    const kind = fileKind(document.documentName);
    const name = downloadName(document.documentName);
    const size = fileSize(document.fileSize);
    const ownerName =
        document.owner || (document.uploadBy === "Vendor" ? "You" : "Admin");

    return (
        <div
            className={`vp-drow${document.isActive ? "" : " off"}${
                menuOpen ? " menu-open" : ""
            }`}
        >
            <div className="vp-card-head">
                <span className={`vp-ftype ${kind.cls}`}>{kind.label}</span>
                <div className="vp-card-title">
                    <div className="vp-fname">{name}</div>
                    <div className="vp-metaline">
                        {size ? <span>{size}</span> : null}
                        <i />
                        <span>{uploadedOn(document.createdDate)}</span>
                        {showCategoryTag && document.categoryName && (
                            <span className="vp-fcategory-tag">
                                {document.categoryName}
                            </span>
                        )}
                    </div>
                </div>

                <div className="vp-ractions">
                    <div className="vp-kebab-wrap">
                        <button
                            type="button"
                            className={`vp-kebab${menuOpen ? " open" : ""}`}
                            onClick={(event) => {
                                event.stopPropagation();
                                onToggleMenu(document);
                            }}
                        >
                            <VendorKebabSvg />
                        </button>

                        {menuOpen && (
                            <div
                                className="vp-kebab-menu"
                                onClick={(event) => event.stopPropagation()}
                            >
                                <button
                                    type="button"
                                    onClick={() => onDetails(document)}
                                >
                                    <VendorInfoSvg size={15} />
                                    Details
                                </button>
                                {canDownload && (
                                    <button
                                        type="button"
                                        onClick={() => onDownload(document)}
                                    >
                                        <VendorDownloadSvg size={15} />
                                        Download
                                    </button>
                                )}
                                {canUpload &&
                                    document.uploadBy === "Vendor" &&
                                    document.isActive && (
                                        <button
                                            type="button"
                                            onClick={() => onShare(document)}
                                        >
                                            <VendorShareSvg size={15} />
                                            Share with HRA Admin
                                        </button>
                                    )}
                                {canUpload && document.isOwnUpload && (
                                    <button
                                        type="button"
                                        className="danger"
                                        onClick={() => onDelete(document)}
                                    >
                                        <VendorTrashSvg size={15} />
                                        Delete
                                    </button>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </div>

            <div className="vp-card-foot">
                <div className="vp-owner">
                    {document.owner && (
                        <span
                            className={`vp-oav${
                                document.uploadBy === "Vendor" ? "" : " admin"
                            }`}
                        >
                            {ownerInitials(ownerName)}
                        </span>
                    )}
                    <span className="vp-oname">
                        {document.owner ? "Shared by " : "Uploaded by "}
                        <b>{ownerName}</b>
                    </span>
                </div>
                {/* the label belongs to the switch - on a row the user cannot
                    toggle it stated a fact they can do nothing about, and read
                    as a disabled control rather than as information */}
                {canUpload && document.isOwnUpload && (
                    <>
                        <span className="vp-stxt">
                            {document.isActive ? "Active" : "Inactive"}
                        </span>
                        <Switch
                            className={`react-switch switch-sm my-tooltip ${
                                document.isActive ? "isActive" : "false"
                            }`}
                            data-tooltip-content={
                                document.isActive ? "Active" : "Inactive"
                            }
                            onChange={() => onToggleStatus(document)}
                            type="checkbox"
                            checked={!!document.isActive}
                            disabled={statusUpdating}
                        />
                    </>
                )}
            </div>
        </div>
    );
};

export default DocumentRow;
